import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface LegacyLeadRequest{
  userId: string;
  leadListId: string;
}

@Injectable({
  providedIn: 'root'
})
export class LegacyLeadService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  legacyLead(userId:string, leadListId: string){
    let url = `${this.apiUrl}/migrate-lead-list-legacy`

    const payload: LegacyLeadRequest = {userId, leadListId};
    return this.http.post(url, payload);
  }
}

export default LegacyLeadService